/**
 * <Layout />
 *
 * Top-level page wrapper -- header, outlet for route-level content, and
 * mobile bottom navigation. Reserves bottom padding on mobile so page
 * content is never hidden beneath the fixed nav bar.
 */
import * as React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { BottomNav } from "./BottomNav";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";

export function Layout() {
  return (
    <div className="min-h-dvh bg-surface text-ink flex flex-col">
      {/* Skip-link is a tiny but important a11y win -- keyboard users can
          jump past the header straight to the content on Tab-1. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:bg-ink focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:font-semibold"
      >
        Skip to main content
      </a>

      <Header />

      <main
        id="main-content"
        data-testid="main-content"
        className="flex-1 w-full pb-24 md:pb-12"
      >
        <Outlet />
      </main>

      <Footer />
      <BottomNav />
      <CookieBanner />
    </div>
  );
}
